import { put } from 'redux-saga/effects';

import { getLocalTimerId } from 'features/userAppliances/localTimer/getLocalTimerId';
import {
  userApplianceReadingsUpdated,
  UserApplianceReadingType,
  userApplianceStateSet,
} from 'features/userAppliances/userAppliancesSlice';
import type { DropStepClient } from 'types/api/step';
import { DropApplianceState } from 'types/api/userAppliance';

export function* requestLocalTimerCancel({ step }: { step: DropStepClient }) {
  const id = getLocalTimerId(step.id);

  yield put(
    userApplianceStateSet({
      id,
      applianceState: DropApplianceState.Ready,
      stepId: step.id,
    })
  );

  yield put(
    userApplianceReadingsUpdated({
      id,
      reading: {
        type: UserApplianceReadingType.TimeTarget,
        value: undefined,
      },
    })
  );

  yield put(
    userApplianceReadingsUpdated({
      id,
      reading: {
        type: UserApplianceReadingType.TimeRemaining,
        value: undefined,
      },
    })
  );
}
